import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

@Component({
  selector: 'lib-formly-switch',
  imports: [NzFormModule, ReactiveFormsModule, CommonModule, NzSwitchModule],
  templateUrl: './formly-switch.component.html',
  styleUrl: './formly-switch.component.scss',
})
export class FormlySwitchComponent extends FieldType<FieldTypeConfig> {}
